import React, { useState } from 'react';
import { createAdminUser } from '../../services/AdminUserApi';
import './CreateAdminModal.css';
import Swal from 'sweetalert2';

const CreateAdminModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    email: '',
    role: 'ADMIN',
    status: 'ACTIVE',
    notes: ''
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

  const validateForm = () => {
    const newErrors = {};

    // Email validation
    if (!formData.email) {
      newErrors.email = 'Email is Required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Invalid Email Format';
    } else if (formData.email.length > 60) {
      newErrors.email = 'Email must not exceed 60 characters';
    }

    // Role validation
    if (!formData.role) {
      newErrors.role = 'Role is required';
    }

    // Notes length validation
    if (formData.notes.length > 500) {
      newErrors.notes = 'Notes must be less than 500 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setSubmitting(true);
      await createAdminUser(formData);
      Swal.fire({
        title: "Created Successful",
        text: "Admin user created successfully!",
        icon: "success",
      });
      onSuccess();
    } catch (error) {
      const errorMsg = error.response?.data?.activatedMessage || 
                      error.response?.data?.message ||
                      'Failed to create admin user';
                      Swal.fire({
                        title: "Error",
                        text: errorMsg,
                        icon: "error",
                        confirmButtonText: "OK"
                        });              
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Create New Admin User</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="text"
              maxLength={60}
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="user@maruti.co.in"
              className={errors.email ? 'input-error' : ''}
              disabled={submitting}
            />
            {errors.email && <span className="error-text">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="role">Role *</label>
            <select
              id="role"
              name="role"
              value={formData.role}
              onChange={handleChange}
              className={errors.role ? 'input-error' : ''}
              disabled={submitting}
            >
              <option value="ADMIN">ADMIN</option>
              <option value="SUPER_ADMIN">SUPER_ADMIN</option>
            </select>
            {errors.role && <span className="error-text">{errors.role}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="status">Status</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              disabled={submitting}
            >
              <option value="ACTIVE">ACTIVE</option>
              <option value="INACTIVE">INACTIVE</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="notes">Notes</label>
            <textarea
              id="notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Optional notes about this admin user..."
              rows="3"
              maxLength={500}
              className={errors.notes ? 'input-error' : ''}
              disabled={submitting}
            />
            <span className="char-count">
              {formData.notes.length}/500
            </span>
            {errors.notes && <span className="error-text">{errors.notes}</span>}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={submitting}
            >
              {submitting ? 'Creating...' : 'Create Admin User'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateAdminModal;

